export default function HeroSection() {
  const handleScroll = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="inicio"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
    >
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=modern%20corporate%20office%20building%20in%20Luanda%20Angola%20at%20dusk%2C%20glass%20facade%20reflecting%20golden%20light%2C%20professional%20business%20district%2C%20dramatic%20sky%20with%20deep%20teal%20and%20dark%20blue%20tones%2C%20ultra%20wide%20angle%2C%20cinematic%20photography%2C%20high%20contrast%2C%20architectural%20photography&width=1920&height=1080&seq=hero001&orientation=landscape"
          alt="MoveMind Consulting"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#011820]/95 via-[#011820]/75 to-[#011820]/40" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#011820]/60 via-transparent to-[#011820]/30" />
      </div>

      {/* Decorative geometric */}
      <div className="absolute top-1/4 right-10 md:right-24 opacity-10 hidden md:block">
        <div className="w-64 h-64 border border-[#026A86] rotate-45" />
        <div className="w-48 h-48 border border-[#026A86] rotate-45 absolute top-8 left-8" />
        <div className="w-32 h-32 bg-[#026A86]/20 rotate-45 absolute top-16 left-16" />
      </div>

      {/* Content — centered */}
      <div className="relative z-10 w-full max-w-4xl mx-auto px-6 md:px-10 text-center">
        {/* Tag */}
        <div className="inline-flex items-center gap-2 border border-[#026A86]/60 rounded-full px-4 py-1.5 mb-8">
          <div className="w-1.5 h-1.5 rounded-full bg-[#026A86]" />
          <span className="text-[#026A86] text-xs font-medium tracking-widest uppercase">
            Consultoria Estratégica · Angola
          </span>
        </div>

        {/* Main Title */}
        <h1 className="text-4xl md:text-6xl font-bold text-white leading-tight mb-6">
          Transformamos{' '}
          <span className="text-[#026A86]">desafios</span>
          <br />
          em oportunidades
          <br />
          de sucesso
        </h1>

        {/* Subtitle */}
        <p className="text-white/60 text-base md:text-lg font-light leading-relaxed mb-10 max-w-xl mx-auto">
          Soluções completas para o seu negócio. Estratégia, Due Diligence,
          Fusões &amp; Aquisições e muito mais — com rigor e excelência.
        </p>

        {/* CTAs */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <button
            onClick={() => handleScroll('#contacto')}
            className="flex items-center gap-3 bg-[#026A86] hover:bg-[#035f78] text-white font-semibold px-8 py-4 rounded-full transition-all duration-300 cursor-pointer whitespace-nowrap group"
          >
            Fale Connosco
            <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform duration-200" />
          </button>
          <button
            onClick={() => handleScroll('#servicos')}
            className="flex items-center gap-2 text-white/70 hover:text-white text-sm font-medium underline underline-offset-4 transition-colors duration-200 cursor-pointer whitespace-nowrap"
          >
            Conhecer os Serviços
          </button>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 opacity-50">
        <span className="text-white text-xs tracking-widest uppercase">Scroll</span>
        <div className="w-px h-10 bg-gradient-to-b from-white to-transparent" />
      </div>
    </section>
  );
}
